import { useEffect, useState } from "react";
let idCounter = 0;
const genId = ()=>{
    idCounter += 1;
    return idCounter;
};
function useUniqueId() {
    const [id, setId] = useState(null);
    useEffect(()=>setId(genId()), []);
    return id;
}
const src_useUniqueId = useUniqueId;
export default src_useUniqueId;
